const ApprovalsGroupModalUser = ({
  skeleton,
  user,
  limitType,
  selectUserHandler,
}) => {
  if (skeleton) {
    return (
      <li className="user__wrapper fl pt-12 pb-10">
        <div className="user__checkbox-wrapper fl jc-c ai-c">
          <div className="skeleton__checkbox skeleton" />
        </div>
        <div className="skeleton__details height-100 fl fl-col jc-sb">
          <div className="skeleton__label skeleton" />
          <div className="skeleton__email skeleton" />
        </div>
        <div className="user__limit mb-0 ml-auto">
          <div className="skeleton__value skeleton" />
        </div>
      </li>
    );
  }

  const {
    customer_id: customerId,
    forename,
    surname,
    email,
    credit_limit: creditLimit,
    max_approval_limit: maxApprovalLimit,
    selected,
  } = user;

  let value = 'No Limit';
  if (limitType === 'Credit') value = `£${creditLimit}`;
  if (limitType === 'Approval') value = `£${maxApprovalLimit}`;

  return (
    <li className="user__wrapper fl pt-12 pb-10">
      <div className="user__checkbox-wrapper fl jc-c ai-c">
        <input
          id={customerId}
          aria-describedby={`${customerId}-email`}
          type="checkbox"
          onChange={() => selectUserHandler(customerId)}
          checked={selected ? 'checked' : ''}
        />
      </div>
      <div className="fl fl-col jc-sb">
        <label
          htmlFor={customerId}
          data-testid="user-name"
          className="ff-body fw-600 fs-14 tc-grey-70 lh-1-1 mb-0">
          {`${forename} ${surname}`}
        </label>
        <p
          id={`${customerId}-email`}
          className="ff-body fs-14 tc-grey-50 lh-1-1 mb-0">
          {email}
        </p>
      </div>
      <p
        className="user__limit ff-body fw-600 fs-14 tc-grey-70 lh-1-1 mb-0 ml-auto"
        data-testid="user-limit">
        {value}
      </p>
    </li>
  );
};

export default ApprovalsGroupModalUser;
